module.exports = __webpack_public_path__ + "img/physics_chemistry_biochemistry.25452fde.svg";